import React from "react";
import Features from "../modules/Features.js";

const Contact = () => {
	return <Features />;
};

export default Contact;